import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
import IconBase, { IconProps } from '../IconBase';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const IconLockLocked16 = (baseProps: IconProps, ref: Ref<SVGSVGElement>) => {
  return <IconBase {...baseProps}>
        {({
      title,
      titleId,
      ...props
    }: Partial<React.SVGProps<SVGSVGElement>> & SVGRProps) => <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fillRule="evenodd" clipRule="evenodd" d="M8.00004 0.73999C5.93449 0.73999 4.26004 2.41445 4.26004 4.47999V5.05999H2.24004H1.54004V5.75999V14.56V15.26H2.24004H13.76H14.46V14.56V5.75999V5.05999H13.76H11.74V4.47999C11.74 2.41445 10.0656 0.73999 8.00004 0.73999ZM10.34 4.47999V5.05999H5.66004V4.47999C5.66004 3.18764 6.70769 2.13999 8.00004 2.13999C9.29239 2.13999 10.34 3.18764 10.34 4.47999ZM2.94004 13.86V6.45999H13.06V13.86H2.94004ZM7.30004 10.3143V10.96V12.24H8.70004V10.96V10.3143C8.95609 10.1091 9.12004 9.79368 9.12004 9.43999C9.12004 8.82143 8.6186 8.31999 8.00004 8.31999C7.38148 8.31999 6.88004 8.82143 6.88004 9.43999C6.88004 9.79368 7.04399 10.1091 7.30004 10.3143Z" fill="currentColor" /></svg>}
      </IconBase>;
}; // This explicit type declaration prevents TypeScript from expanding IconProps into a huge Pick type
const ForwardRef: React.ForwardRefExoticComponent<IconProps & React.RefAttributes<SVGSVGElement>> = React.forwardRef<SVGSVGElement, IconProps>((props, ref) => {
  return IconLockLocked16(props, ref);
});
export default ForwardRef;